export function get_props(id){
	try {
		return JSON.parse(document.getElementById(id).textContent)
	} catch (e) {
		return {}
	}
}

export function merge(a, b) {
	return Object.assign({}, a, b);
}